<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 1920 1920"
    xmlns="http://www.w3.org/2000/svg">
      <path
        d="M338.79-.011v527.66L-.034 821.298V1919.99h1920V821.297l-338.71-293.647V-.011H338.79Zm112.94 1203.953V112.93h1016.471v1091.012l-189.289 151.34H641.02l-189.29-151.34Zm1129.526-526.87 225.882 195.726v60.085l-225.882 180.706V677.07ZM112.907 932.881v-60.084L338.79 677.071v436.518L112.907 932.883Zm1694.23 144.678v623.323l-238.08-301.553-88.658 70.023 266.654 337.695H172.88l266.767-337.695-88.659-70.023-238.08 301.553V1077.56l488.47 390.777h717.29l488.47-390.777Zm-790.666-795.207v282.353h282.353v112.941H1016.47V960H903.529V677.647H621.176V564.706H903.53V282.353h112.942Z"
        fill-rule="evenodd"
        :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#89899B'
    },
    height: String,
    width: String
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/shared/icons/BusinessInvitationsIcon.vue